import { render, staticRenderFns } from "./combinationTwo.vue?vue&type=template&id=34c0c1d2&scoped=true"
import script from "./combinationTwo.vue?vue&type=script&lang=js"
export * from "./combinationTwo.vue?vue&type=script&lang=js"
import style0 from "./combinationTwo.vue?vue&type=style&index=0&id=34c0c1d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c0c1d2",
  null
  
)

export default component.exports